import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { getDialogContextValue } from '../../../../redux/selectors';

import ReduxDialog from '../../../Common/ReduxDialog';

import styles from './styles';

import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import { saveJobProfileFormHandler } from '../../../../redux/routines';
import { required } from '../../../../utils/formvalidation';
import { renderJobProfileStages, renderTextField } from '../../../../utils/reduxforms';
import { JOB_PROFILE_DIALOG } from '../../../../redux/constants/dialogs';

class JobProfileDialog extends Component {
  // handleAddStage = () => {
  //   // this.props.setStage({ id: id() });
  //   this.props.showDialog(STAGE_DIALOG, {
  //     stage: {
  //       icon: 'print',
  //     },
  //   });
  // };

  // handleEditStage = (stage) => {
  //   console.log('handleEditStage');
  //   this.props.setStage(stage);
  //   this.props.showDialog(STAGE_DIALOG, { stage });
  // };

  // handleSaveStage = (stage) => {
  //   console.log('stage', stage);
  //   this.props.saveStage(stage);
  //
  // this.props.hideDialog('stage');
  // };

  // handleRemoveStage = (jobProfile, stage) => {
  //   const context = {
  //     type: 'warning',
  //     title: 'Remove Stage?',
  //     message: 'Are you sure you wish to remove this stage?',
  //     buttons: [
  //       <Button         variant="text"
  //         label="Cancel"
  //         onClick={() => this.props.hideDialog('confirm')}
  //       />,
  //       <Button         variant="text"
  //         label="Remove"
  //         onClick={() => {
  //           this.props.hideDialog('confirm');
  //           this.props.removeStage(jobProfile, stage.id);
  //         }}
  //       />,
  //     ],
  //   };
  //
  //   this.props.showDialog(CONFIRM_DIALOG, context);
  // };

  render() {
    const { handleSubmit, initialValues, showDialog } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(JOB_PROFILE_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        onClick={() => this.props.submit(JOB_PROFILE_DIALOG)}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        title={initialValues.get('name') || 'Create Job Profile'}
        subTitle={'A job profile allows you to configure the stages a task must progress through to be completed'}
        actions={actions}
        name={JOB_PROFILE_DIALOG}
        fullWidth
        maxWidth="sm"
      >
        <Form onSubmit={handleSubmit(saveJobProfileFormHandler)} style={styles.form}>
          <Grid container spacing={8}>
            <Grid item xs>
              <Field
                name="name"
                component={renderTextField}
                label="Name"
                fullWidth
                validate={[required]}
              />
            </Grid>
          </Grid>
          <Grid container spacing={8}>
            <Grid item xs>
              <Field
                name="description"
                component={renderTextField}
                label="Description"
                fullWidth
                multiline
                rows={2}
              />
            </Grid>
          </Grid>

          <Grid container spacing={8}>
            <Grid item xs>
              <Field
                name="stages"
                component={renderJobProfileStages}
                fullWidth
                showDialog={showDialog}
              />
            </Grid>
          </Grid>
        </Form>

      </ReduxDialog>
    );
  }
}

JobProfileDialog.propTypes = {
  initialValues: PropTypes.object.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: JOB_PROFILE_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubmitSuccess');
    props.hideDialog(JOB_PROFILE_DIALOG);
  },
  onSubmitFail: (err) => {
    console.log('onSubmitFail', err);
  },
})(JobProfileDialog);

function mapStateToProps(state) {
  return {
    initialValues: getDialogContextValue(state)(JOB_PROFILE_DIALOG, 'profile'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/JobProfileDialog/index.js